import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-split-view',
  templateUrl: './split-view.component.html',
  styleUrls: ['./split-view.component.scss'],
})
export class SplitViewComponent {


}
